<template>
<svg data-svg-lvl-2="flyleafend-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430">
<PreviewLayersFlyleafendBlockShadowRHL :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleafendBlockShadowRHL_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleafendBlockFlyleafendRHL :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleafendBlockFlyleafendRHL_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleafendBlockContourRHL :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleafendBlockContourRHL_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleafendBlockEnvelopeR :params="params" v-if="params.envelopeColor" />
<PreviewLayersFlyleafendBlockPocketR :params="params" v-if="params.flyleafendPocket" />
</svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>